// All timestamps from the backend are real UTC instants; display them in the
// business's home timezone (Eastern/"Miami time") regardless of the viewer's
// own browser timezone, so everyone sees the same wall-clock time.
const TIME_ZONE = 'America/New_York'

export const formatDateTime = (value: string | Date): string =>
  new Date(value).toLocaleString('en-US', { timeZone: TIME_ZONE })

export const formatDateTimeShort = (value: string | Date): string =>
  new Date(value).toLocaleString('en-US', { dateStyle: 'short', timeStyle: 'short', timeZone: TIME_ZONE })

export const formatDate = (value: string | Date): string =>
  new Date(value).toLocaleDateString('en-US', { timeZone: TIME_ZONE })

// LeadDate/MoveDate/DeliveryDate are plain calendar dates with no real time-of-day —
// the backend stores them as UTC midnight only because the DB column type requires a
// timezone-aware timestamp. Converting them to TIME_ZONE like real instants shifts them
// a day backward for viewers behind UTC (e.g. 2026-08-01T00:00:00Z -> "7/31/2026" in
// America/New_York). Read the UTC Y-M-D components as sent, with no conversion.
export const formatCalendarDate = (value: string | Date): string => {
  const date = new Date(value)
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()).toLocaleDateString('en-US')
}
